module.exports = __webpack_public_path__ + "assets/img/robo_orange.622b6f1d.svg";